import { RealEstateCategory } from "@/api/types";
import FormInput from "@/components/Form/FormInput";
import { useTrans } from "@/translations";

import { FC } from "react";
import { UseFormReturn } from "react-hook-form";

export type TerminalFormData = {
  name: string;
  category: RealEstateCategory;
  contactEmail: string;
  area: string;
  coordinates?: string;
  street?: string;
  postalCode?: string;
  postalRegion?: string;
  country?: string;
};

interface TerminalFormProps {
  formHandler: UseFormReturn<TerminalFormData>;
}

export const TerminalForm: FC<TerminalFormProps> = ({ formHandler }) => {
  const { t } = useTrans();
  const {
    register,
    formState: { errors },
  } = formHandler;

  return (
    <div className="mb-6">
      <FormInput
        name="name"
        label={t("formLabels:name")}
        register={register}
        error={errors?.name}
        required
        showErrorInTooltip={false}
      />
    </div>
  );
};
